// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-6hG","option":"styles_option__kcJm7","selected":"styles_selected__1E6Q4"};